// Get currently logged in user
import { QuestionTypes } from "../enums/questiontypes";

export interface HealthCheckQuestion {
  question: string;
  answer:
    | string
    | boolean
    | HealthCheckQuestion
    | Array<HealthCheckQuestion>
    | null;
  type: QuestionTypes | null;
  rules: any | null;
}

export function getQuestions(): Array<HealthCheckQuestion> {
  return [
    {
      question:
        "Have you experienced any of the following symptoms in the past 72 hours?",
      answer: [
        {
          question: "Fever (>100.4)",
          answer: null,
          type: QuestionTypes.CHECKBOX_YES_OR_NO,
          rules: [(v: any) => v != null || "You must select one."]
        },
        {
          question: "Cough &/or shortness of breath (not activity related)",
          answer: null,
          type: QuestionTypes.CHECKBOX_YES_OR_NO,
          rules: [(v: any) => v != null || "You must select one."]
        },
        {
          question: "Sore throat, runny nose &/or loss of taste or smell",
          answer: null,
          type: QuestionTypes.CHECKBOX_YES_OR_NO,
          rules: [(v: any) => v != null || "You must select one."]
        },
        {
          question: "Nausea, vomiting &/or diarrhea",
          answer: null,
          type: QuestionTypes.CHECKBOX_YES_OR_NO,
          rules: [(v: any) => v != null || "You must select one."]
        },
        {
          question: "Headache, chills, &/or muscle aches",
          answer: null,
          type: QuestionTypes.CHECKBOX_YES_OR_NO,
          rules: [(v: any) => v != null || "You must select one."]
        }
      ],
      rules: null,
      type: QuestionTypes.GROUP
    },
    {
      question:
        "Have you had close contact or cared for someone with COVID-19 within the past 14 days?",
      answer: null,
      type: QuestionTypes.CHECKBOX_YES_OR_NO,
      rules: [(v: any) => v != null || "You must select one."]
    },
    {
      question:
        "Have you returned from travel outside the US or on a cruise ship or riverboat within the past 14 days?",
      answer: null,
      type: QuestionTypes.CHECKBOX_YES_OR_NO,
      rules: [(v: any) => v != null || "You must select one."]
    }
  ];
}
